import styles from './ExtendedInformationModule.module.scss';
import { DeepReadonly } from 'ts-essentials';
import { ExtendedMessage } from '../models/extendedMessage';

interface ExtendedInformationModuleProps {
  extendedMessages: DeepReadonly<ExtendedMessage[]>;
}

export default function ExtendedInformationModule({
  extendedMessages,
}: ExtendedInformationModuleProps) {
  if (extendedMessages[0] === undefined) {
    return null;
  }

  const extendedMessage = extendedMessages[0];

  return (
    <img
      className={styles.image}
      src={`/api/extended-messages/${extendedMessage.id}/image/${extendedMessage.imageHash}`}
    />
  );
}
